import { render, staticRenderFns } from "./NgtorchRunChip.vue?vue&type=template&id=8aa949ec&"
import script from "./NgtorchRunChip.vue?vue&type=script&lang=js&"
export * from "./NgtorchRunChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports